"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import { auditBillingEnabledFor } from "./audit_billing";
import CarrierName from "../carrier_name";
import DisablingButton from "../../components/disabling_button";
import generalFormatter from "../../formatters/general";
import { isFactorAccount } from "../../helpers/app";
import { v4 as uuid } from "@lukeed/uuid/secure";
import { isLtlReconcileEnabled } from "../ltl/reconcile";
import LtlHeader from "../ltl/indexer_header";
import { boxIcon, truckIcon } from "../ui/header_icons";
import { arrowDown, arrowUp, copyIcon, warningIcon } from "../ui/icons";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
import { Tooltip, TooltipDirection, TooltipLocation } from "../ui/v3/tooltip";
import { StatusTag, StatusTagStyle, StatusTagSize } from "../ui/v3/status_tag";
import * as popout from "./../popout";
import {
  CustomerMarginHeader,
  CustomerMarginHeaderTooltipPlacement
} from "./customer_margin_header";
function carrierNamePrefix() {
  return /* @__PURE__ */ jsxs(
    "span",
    {
      className: "indexer-header__carrier-label",
      "data-tooltip": true,
      "aria-haspopup": "true",
      title: "The " + Account.carrierTerm() + " associated with this email address",
      children: [
        "Email ",
        Account.carrierTerm(),
        ":\xA0"
      ]
    }
  );
}
function button(title, callback, index, icon = "") {
  if (icon) {
    const iconClasses = "icon icon-" + icon + " icon--no-repeat icon--sm ml-2";
    return /* @__PURE__ */ jsxs(
      "button",
      {
        className: "v3__button-outlined indexer-header__view-email",
        onClick: callback,
        children: [
          title,
          /* @__PURE__ */ jsx("span", { className: iconClasses })
        ]
      },
      "action-button-" + index
    );
  } else {
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: "v3__button-outlined indexer-header__view-email",
        onClick: callback,
        children: title
      },
      "action-button-" + index
    );
  }
}
function openBillingReqsPopout(customerId) {
  popout.setCustomerId(customerId);
  popout.openOrFocusBillingReqsPopout();
}
function openLoadLink(event) {
  if (event.target.value) {
    window.open(event.target.value, "_blank");
  }
  event.target.value = "";
}
function maybeStatePill(state) {
  return state && /* @__PURE__ */ jsx("div", { className: "indexer-header__customer-state", children: state });
}
function maybeStatePillV3Reskin(state) {
  return state && /* @__PURE__ */ jsx("span", { style: { marginLeft: "4px" }, children: /* @__PURE__ */ jsx(
    StatusTag,
    {
      content: state,
      style: StatusTagStyle.Info,
      size: StatusTagSize.Small
    }
  ) });
}
function showCustomerStatuses(props) {
  return auditBillingEnabledFor(props.invoice, props.load);
}
function renderDefault(props, state) {
  const email = props.email || {};
  let subject = email.subject || "Uploaded Document";
  let subtitle = email.sender_address;
  if (props.displayReference && props.load) {
    const referenceLabel = Account.currentSettings().load_display_reference_label;
    const referenceKey = Account.currentSettings().load_display_reference_key;
    const referenceValue = props.load.references[referenceKey];
    if (referenceValue) {
      subject = `${referenceLabel} ${referenceValue}`;
      subtitle = `Load ${props.load.load_id}`;
    }
  }
  return /* @__PURE__ */ jsxs("div", { className: "indexer-header__container", children: [
    /* @__PURE__ */ jsxs("div", { className: "indexer-header__subject-area", children: [
      /* @__PURE__ */ jsx("div", { className: "indexer-header__subject", children: subject }),
      /* @__PURE__ */ jsx("div", { className: "indexer-header__subtitle", children: subtitle }),
      displayCustomerMargin(props) && renderDateTime(props)
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "indexer-header__action-area", children: [
      /* @__PURE__ */ jsxs("div", { className: "indexer-header__date-area", children: [
        !displayCustomerMargin(props) && renderDateTime(props),
        /* @__PURE__ */ jsxs("div", { className: "indexer-header__customer_carrier-area", children: [
          renderCustomerNames(props),
          renderCarrier(props)
        ] }),
        displayCustomerMargin(props) && /* @__PURE__ */ jsx(
          CustomerMarginHeader,
          {
            invoice: props.invoice,
            tooltipPlacement: CustomerMarginHeaderTooltipPlacement.After,
            useV3Typography: false,
            labelValueSeparator: ":"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("div", { className: "indexer-header__center-action-area" }),
      /* @__PURE__ */ jsxs("div", { className: "indexer-header__right-action-area", children: [
        markCompleteButton(props, state),
        ignoreEntryButton(props, state),
        renderActions(props),
        loadLinks(props)
      ] })
    ] })
  ] });
}
function renderLtl(props, state, displayProNumber) {
  let referenceLabel = null, referenceValue = null;
  if (props.displayReference && props.load) {
    referenceLabel = Account.currentSettings().load_display_reference_label;
    const referenceKey = Account.currentSettings().load_display_reference_key;
    referenceValue = props.load.references[referenceKey];
  }
  return /* @__PURE__ */ jsxs("div", { className: "indexer-header__action-area-ltl", children: [
    /* @__PURE__ */ jsx(
      LtlHeader,
      {
        displayProNumber,
        email: props.email,
        invoice: props.invoice,
        load: props.load,
        location: props.location,
        referenceLabel,
        referenceValue
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "indexer-header__right-action-area-ltl indexer-header__right-action-area", children: [
      markCompleteButton(props, state),
      ignoreEntryButton(props, state),
      renderActions(props),
      loadLinks(props)
    ] })
  ] });
}
function renderActions(props) {
  var _a;
  return _.map((_a = props.actions) != null ? _a : [], (action, index) => {
    return button(action[0], action[1], index, action[2]);
  });
}
function markCompleteButton(props, state) {
  if (props.canMarkComplete) {
    return /* @__PURE__ */ jsx(
      DisablingButton,
      {
        className: "v3__button-tertiary indexer-header__ignore-link",
        disabledText: "Ignoring...",
        onClick: props.markComplete,
        children: "Ignore This Entry"
      }
    );
  }
}
function ignoreEntryButton(props, state) {
  if (props.canIgnoreEntry) {
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: "v3__button-tertiary indexer-header__ignore-link",
        onClick: () => {
          var _a;
          return (_a = props.ignoreEntry) == null ? void 0 : _a.call(props);
        },
        children: "Ignore All Groups"
      }
    );
  }
}
function loadLinks(props) {
  const links = props.load && props.load.data && props.load.data.links || [];
  if (links.length === 0) {
    return null;
  }
  const selectOptions = links.map((x, i) => /* @__PURE__ */ jsx("option", { value: x.url, children: x.text }, i));
  return /* @__PURE__ */ jsxs(
    "select",
    {
      value: void 0,
      onChange: openLoadLink,
      className: "indexer-header__load-links",
      children: [
        /* @__PURE__ */ jsx("option", { value: "", children: "Links to TMS" }),
        selectOptions
      ]
    }
  );
}
function customerDetails(props) {
  if (!(Account.useBillingReqsPopout() && Account.hasRole("Broker"))) {
    return null;
  }
  const load = props.load;
  const loadShipments = (load == null ? void 0 : load.tms_load_shipments) || [];
  const loadShipment = loadShipments[0];
  const customerId = loadShipment == null ? void 0 : loadShipment.customer_id;
  const showAlertIcon = loadShipments == null ? void 0 : loadShipments.some(
    (shipment) => shipment.customer_instructions && shipment.customer_instructions.length > 0
  );
  const alertIcon = /* @__PURE__ */ jsx(
    Tooltip,
    {
      content: /* @__PURE__ */ jsx(
        "span",
        {
          style: {
            position: "relative",
            top: "2px"
          },
          children: warningIcon()
        }
      ),
      tooltipContent: "Customer instructions are present",
      direction: TooltipDirection.Left,
      location: TooltipLocation.Hidden
    }
  );
  return /* @__PURE__ */ jsxs(
    Button,
    {
      size: ButtonSize.Medium,
      variant: ButtonVariant.Text,
      onClick: () => openBillingReqsPopout(customerId),
      children: [
        showAlertIcon && alertIcon,
        "Customer details"
      ]
    }
  );
}
function setCarrierLink(props) {
  if (props.canSetCarrier) {
    return /* @__PURE__ */ jsxs(
      "a",
      {
        className: "indexer-header__set-carrier-link",
        onClick: props.setCarrier,
        children: [
          /* @__PURE__ */ jsx("span", { children: "\xA0" }),
          /* @__PURE__ */ jsx("i", { className: "fi-pencil" })
        ]
      }
    );
  }
}
function renderCarrier(props) {
  return /* @__PURE__ */ jsxs("div", { className: "indexer-header__customer_carrier-area--row", children: [
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      CarrierName,
      {
        carrierID: props.email.carrier_id,
        multiple: props.email.single_carrier === false,
        displayAccountExec: isFactorAccount(),
        displayNoBuy: isFactorAccount(),
        carrierNameSuffix: setCarrierLink(props),
        carrierNamePrefix: carrierNamePrefix(),
        v3ReskinEnabled: props.v3ReskinEnabled
      }
    ) }),
    maybeStatePill(props.invoice && props.invoice.status)
  ] });
}
function renderCustomerNames(props) {
  const customers = customerLines(props);
  if (customers.length < 3) {
    return customers.map((customer) => /* @__PURE__ */ jsxs(
      "div",
      {
        className: "indexer-header__customer_carrier-area--row",
        children: [
          /* @__PURE__ */ jsxs("div", { children: [
            "Customer: ",
            customer.name
          ] }),
          maybeStatePill(customer.customer_display_status)
        ]
      },
      customer.key
    ));
  } else {
    const lines = customers.map((customer) => {
      const statusDisplay = showCustomerStatuses(props) ? "	" + (customer.customer_display_status || "<no status>") : "";
      return `${customer.name}${statusDisplay}`;
    }).join("\n");
    const namesStr = `Customer Names:

${lines}`;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        title: namesStr,
        className: "indexer-header__customer_carrier-area--row",
        children: [
          /* @__PURE__ */ jsx("div", { children: "Multiple Customers" }),
          showCustomerStatuses(props) && maybeStatePill(props.invoice && props.invoice.billing_display_status)
        ]
      }
    );
  }
}
function renderCustomerNamesV3Reskin(props) {
  const customers = customerLines(props);
  if (customers.length < 3) {
    return customers.map((customer, i) => /* @__PURE__ */ jsxs("span", { children: [
      /* @__PURE__ */ jsx("span", { children: customer.name }),
      maybeStatePillV3Reskin(customer.customer_display_status),
      i == 0 && customers.length > 1 ? ", " : ""
    ] }, customer.key));
  } else {
    const tooltipContent = customers.map((customer) => {
      const statusDisplay = showCustomerStatuses(props) ? " : " + (customer.customer_display_status || "<no status>") : "";
      return /* @__PURE__ */ jsx(
        "div",
        {
          style: { whiteSpace: "nowrap" },
          children: `${customer.name}${statusDisplay}`
        },
        customer.key
      );
    });
    return /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "var(--space-xxxs)" }, children: [
      /* @__PURE__ */ jsx(
        Tooltip,
        {
          content: /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                textDecoration: "underline",
                textDecorationStyle: "dotted"
              },
              children: "Multiple"
            }
          ),
          tooltipContent,
          direction: TooltipDirection.Right,
          location: TooltipLocation.Hidden
        }
      ),
      showCustomerStatuses(props) && maybeStatePillV3Reskin(
        props.invoice && props.invoice.billing_display_status
      )
    ] });
  }
}
function customerLines(props) {
  const auditBillingEnabled = showCustomerStatuses(props);
  const load = props.load;
  const loadShipments = load && load.tms_load_shipments || [];
  const customers = {};
  let order = 0;
  if (load && load.customer && load.customer.name) {
    const ls = showCustomerStatuses(props) && loadShipments.find((x) => x.customer_name === load.customer.name);
    customers[load.customer.name] = {
      key: load.customer.name,
      name: load.customer.name,
      // there is an assumption that a load shipment will exist for the same customer as the load.
      // If one doesn't, we simply will not display a status since it is technically possible to not exist despite the assumption.
      customer_display_status: ls && ls.customer_display_status,
      order: order++
    };
  } else if (load && !load.customer && auditBillingEnabled) {
    customers[uuid()] = {
      // uuid is used here to ensure that each Missing Customer is treated as unique, since shipments missing customers may be for different customers and thus have distinct statuses.
      key: `(Missing Customer)-${order}`,
      name: "(Missing Customer)",
      customer_display_status: null,
      order: order++
    };
  }
  loadShipments.forEach((ls) => {
    if (ls.customer_name && !customers[ls.customer_name]) {
      customers[ls.customer_name] = {
        key: ls.customer_name,
        name: ls.customer_name,
        customer_display_status: showCustomerStatuses(props) && ls.customer_display_status,
        order: order++
      };
    } else if (!ls.customer_name && auditBillingEnabled) {
      customers[uuid()] = {
        // uuid is used here to ensure that each Missing Customer is treated as unique, since shipments missing customers may be for different customers and thus have distinct statuses.
        key: `(Missing Customer)-${order}`,
        name: "(Missing Customer)",
        customer_display_status: showCustomerStatuses(props) && ls.customer_display_status,
        order: order++
      };
    }
  });
  return _.sortBy(Object.values(customers), (x) => x.order);
}
function renderDateTime(props) {
  const email = props.email || {};
  return /* @__PURE__ */ jsxs("div", { className: "indexer-header__date-time", children: [
    /* @__PURE__ */ jsx("span", { className: "indexer-header__date", children: generalFormatter.shortDate(email.created_at) }),
    /* @__PURE__ */ jsxs("span", { className: "indexer-header__time", children: [
      " ",
      generalFormatter.shortTime(email.created_at)
    ] })
  ] });
}
function displayCustomerMargin(props) {
  return Account.currentSettings().display_customer_margin_in_header && props.invoice;
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      copyTooltipText: "Copy",
      linksOpen: false
    });
    __publicField(this, "renderV3Reskin", () => {
      var _a;
      const displayProNumber = this.props.invoice && isLtlReconcileEnabled(this.props.invoice);
      let reference;
      if (this.props.displayReference && this.props.load) {
        const referenceLabel = Account.currentSettings().load_display_reference_label;
        const referenceKey = Account.currentSettings().load_display_reference_key;
        const referenceValue = this.props.load.references[referenceKey];
        if (referenceValue) {
          reference = /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "var(--space-xxxs)" }, children: [
            /* @__PURE__ */ jsx("span", { className: "v3__type__small-body-semi-bold", children: referenceLabel }),
            /* @__PURE__ */ jsx("span", { children: referenceValue })
          ] });
        }
      }
      const topLeftColumn = /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexFlow: "column", gap: "6px" }, children: [
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("span", { style: { color: "var(--color-grayscale-600)" }, children: boxIcon() }),
          /* @__PURE__ */ jsx(
            "span",
            {
              className: "v3__type__small-body-semi-bold",
              style: { margin: "0 4px" },
              children: "Customer"
            }
          ),
          /* @__PURE__ */ jsx("span", { children: renderCustomerNamesV3Reskin(this.props) })
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("span", { style: { color: "var(--color-grayscale-600)" }, children: truckIcon() }),
          /* @__PURE__ */ jsx(
            "span",
            {
              className: "v3__type__small-body-semi-bold",
              style: { margin: "0 4px" },
              children: "Carrier"
            }
          ),
          /* @__PURE__ */ jsx(
            CarrierName,
            {
              carrierID: this.props.email.carrier_id,
              multiple: this.props.email.single_carrier === false,
              displayAccountExec: false,
              displayNoBuy: false,
              carrierNameSuffix: "",
              carrierNamePrefix: "",
              v3ReskinEnabled: this.props.v3ReskinEnabled,
              carrierInvoices: this.props.carrierInvoices,
              trailingChip: maybeStatePillV3Reskin(
                this.props.invoice && this.props.invoice.status
              )
            }
          )
        ] })
      ] });
      const bottomLeftColumn = /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexFlow: "column", gap: "6px" }, children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              gap: "var(--space-xxxs)"
            },
            children: [
              /* @__PURE__ */ jsx("span", { className: "v3__type__small-body-semi-bold", children: "Load" }),
              /* @__PURE__ */ jsx("span", { children: this.props.load.load_id }),
              /* @__PURE__ */ jsx(
                Tooltip,
                {
                  content: /* @__PURE__ */ jsx("span", { className: "copy-icon", onClick: this.copyLoadId, children: copyIcon() }),
                  tooltipContent: this.state.copyTooltipText,
                  direction: TooltipDirection.Right,
                  location: TooltipLocation.Hidden,
                  onClick: this.copyLoadId
                }
              )
            ]
          }
        ),
        displayProNumber && /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "var(--space-xxxs)" }, children: [
          /* @__PURE__ */ jsx("span", { className: "v3__type__small-body-semi-bold", children: "Pro number" }),
          /* @__PURE__ */ jsx("span", { children: this.props.load.pro_number })
        ] }),
        reference
      ] });
      const buttons = _.map((_a = this.props.actions) != null ? _a : [], function(action, index) {
        const title = action[0];
        const callback = action[1];
        return /* @__PURE__ */ jsx(
          Button,
          {
            size: ButtonSize.Medium,
            variant: ButtonVariant.Outlined,
            onClick: callback,
            children: title
          },
          "action-button-" + index
        );
      });
      const topRightColumn = /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            display: "flex",
            flexFlow: "column",
            justifyContent: "space-between",
            alignItems: "end",
            gap: "var(--space-xxs)"
          },
          children: /* @__PURE__ */ jsx("div", { style: { display: "flex", gap: "var(--space-xxs)" }, children: buttons })
        }
      );
      const bottomRightColumn = /* @__PURE__ */ jsxs(
        "div",
        {
          style: { display: "flex", gap: "var(--space-xxs)", alignItems: "end" },
          children: [
            customerDetails(this.props),
            this.loadLinksV3Reskin()
          ]
        }
      );
      return /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            display: "flex",
            flexFlow: "column",
            gap: "var(--space-xxs)"
          },
          children: [
            /* @__PURE__ */ jsxs(
              "div",
              {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "var(--space-xxs)"
                },
                children: [
                  topLeftColumn,
                  topRightColumn
                ]
              }
            ),
            /* @__PURE__ */ jsxs(
              "div",
              {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "var(--space-xxs)"
                },
                children: [
                  bottomLeftColumn,
                  bottomRightColumn
                ]
              }
            )
          ]
        }
      );
    });
    __publicField(this, "copyLoadId", () => {
      navigator.clipboard.writeText(this.props.load.load_id);
      this.setState({ copyTooltipText: "Copied" });
      setTimeout(() => {
        this.setState({ copyTooltipText: "Copy" });
      }, 1e3);
    });
    __publicField(this, "loadLinksV3Reskin", () => {
      const links = this.props.load && this.props.load.data && this.props.load.data.links || [];
      if (links.length === 0) {
        return null;
      }
      const openDropdown = () => {
        this.setState({ linksOpen: true });
      };
      const closeDropdown = () => {
        this.setState({ linksOpen: false });
      };
      const openLink = (url) => {
        window.open(url, "_blank");
        this.setState({ linksOpen: false });
      };
      const linksList = /* @__PURE__ */ jsxs("div", { style: { position: "relative" }, children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "v3-tertiary-dropdown__scrim",
            onClick: closeDropdown
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "v3-tertiary-dropdown__list", children: links.map((x, i) => /* @__PURE__ */ jsx(
          "div",
          {
            className: "v3-tertiary-dropdown__item",
            onClick: () => openLink(x.url),
            children: x.text
          },
          i
        )) })
      ] });
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs(
          Button,
          {
            size: ButtonSize.Medium,
            variant: ButtonVariant.Text,
            onClick: openDropdown,
            children: [
              "View in TMS ",
              this.state.linksOpen ? arrowUp() : arrowDown()
            ]
          }
        ),
        this.state.linksOpen && linksList
      ] });
    });
  }
  render() {
    if (this.props.v3ReskinEnabled) {
      return this.renderV3Reskin();
    } else if (this.props.isLtlAuditCustomer) {
      const displayProNumber = this.props.invoice && isLtlReconcileEnabled(this.props.invoice);
      return renderLtl(this.props, this.state, displayProNumber);
    } else {
      return renderDefault(this.props, this.state);
    }
  }
}
